import { BaseLandscapeService } from '../../base-landscape.service';
import { LandscapeDocumentResponseDto } from '../dto/response/landscape-document-response.dto';
import { LandscapeDocumentUpdateRequestDto } from '../dto/request/landscape-document-update-request.dto';
import {
  getLanguageKey,
  LocalesLanguagesConstants,
} from '../../../../locales/locales';
import { LandscapeDocumentSaveRequestDto } from '../dto/request/landscape-document-save-request.dto';

class LandscapeDocumentService extends BaseLandscapeService {
  public async fetchLandscapeDocumentById(
    id: string,
    language: LocalesLanguagesConstants = LocalesLanguagesConstants.en
  ): Promise<LandscapeDocumentResponseDto> {
    const response = await this.get<LandscapeDocumentResponseDto>(
      `/document/${id}`,
      {
        headers: {
          'accept-language': getLanguageKey(language),
        },
      }
    );
    return response.data;
  }

  public async fetchLandscapeDocumentsByProjectId(
    projectId: string
  ): Promise<LandscapeDocumentResponseDto[]> {
    const response = await this.get<LandscapeDocumentResponseDto[]>(
      `/document/byprojectid/${projectId}`
    );
    return response.data;
  }

  public async fetchLandscapeDocumentsByLandscapeId(
    landscapeId: string
  ): Promise<LandscapeDocumentResponseDto[]> {
    const response = await this.get<LandscapeDocumentResponseDto[]>(
      `/document/bycompactid/${landscapeId}`
    );
    return response.data;
  }

  public async fetchLandscapeDocumentsByLandscapeIndicatorId(
    landscapeIndicatorId: string
  ): Promise<LandscapeDocumentResponseDto[]> {
    const response = await this.get<LandscapeDocumentResponseDto[]>(
      `/document/bycompactindicatorid/${landscapeIndicatorId}`
    );
    return response.data;
  }

  public async saveLandscapeDocument(
    saveRequest: LandscapeDocumentSaveRequestDto
  ): Promise<LandscapeDocumentResponseDto> {
    const response = await this.post<LandscapeDocumentResponseDto>(
      `/document`,
      saveRequest
    );
    return response.data;
  }

  public async updateLandscapeDocument(
    document: LandscapeDocumentUpdateRequestDto,
    language: LocalesLanguagesConstants = LocalesLanguagesConstants.en
  ): Promise<LandscapeDocumentResponseDto> {
    const response = await this.put<LandscapeDocumentResponseDto>(
      `/document`,
      document,
      {
        headers: {
          'accept-language': getLanguageKey(language),
        },
      }
    );
    return response.data;
  }

  public async deleteLandscapeDocument(
    existingId: string,
    compactId: string | null = null
  ): Promise<void> {
    await this.delete<void>(`/document/${existingId}`, {
      params: {
        compactId,
      },
    });
  }
}

const landscapeDocumentService = new LandscapeDocumentService();
export default landscapeDocumentService;
